import { getCurrSection, setCurrSection } from "../model"
import gsap from "gsap"

const selectBtn = document.querySelector(".sub-nav-view .btn-primary")

/**
 * Handlers
 */

const handleSelectBtnClick = () => {
  const duration = 0.05

  if (getCurrSection() < 3) setCurrSection(getCurrSection() + 1)
  gsap.to(selectBtn, { duration, scale: 0.3, ease: "power4.out" })
  gsap.to(selectBtn, { duration, scale: 1, delay: duration, ease: "power4.inOut" })
}

selectBtn.addEventListener("click", handleSelectBtnClick)
